/* eslint-disable comma-dangle */
/* eslint-disable max-len */

export const GENTATION = {
	"GENTATION_SHIM_GENDER": {
		"1": [21, 17, 20, 1, 4, 16],
		"3": [54, 57, 48, 63],
		"2": [42, 34, 40, 2, 8, 32]
	},
	"SEARCHABLE_GENTATIONS_BY_INTEREST": {
		"1": {
			"1": 20,
			"3": 16,
			"2": 17,
			"4": 21,
		},
		"3": {
			"1": 54,
			"3": 63,
			"2": 57,
			"4": 63
		},
		"2": {
			"1": 34,
			"3": 32,
			"2": 40,
			"4": 42
		},
	},
	"GENDER_ALIASES": {
		"man": 1,
		"MAN": 1,
		"f": 2,
		"Man": 1,
		"F": 2,
		"woman": 2,
		"-": 0,
		"m": 1,
		"M": 1,
		"WOMAN": 2,
		"1": 1,
		"0": 0,
		"2": 2,
		"Woman": 2
	},
	"GENDER_TO_TAG": {
		"2": 0,
		"1": 1
	},
	"GENTATION_SHIM_ORIENTATION": {
		"1": [34, 20, 54, 2, 4],
		"3": [32, 16, 48, 63],
		"2": [17, 40, 57, 1, 8]
	},
	"INTEREST_STRINGS": {
		"1": "Men",
		"3": "Everybody",
		"2": "Women"
	},
	"ORIENTATION_KEYS": [0, 1, 2, 3],
	"GENDER_TAGS_PLURAL": {
		"18": "Transmasculines",
		"19": "Transsexuals",
		"5": "Cis Men",
		"4": "Bigenders",
		"7": "Genderfluids",
		"6": "Cis Women",
		"1": "Men",
		"14": "Pangenders",
		"0": "Women",
		"15": "Transfeminines",
		"3": "Androgynes",
		"16": "Transgenders",
		"2": "Agenders",
		"17": "Trans Men",
		"10": "Hijras",
		"11": "Intersexes",
		"12": "Non-binaries",
		"21": "Two Spirits",
		"13": "Others",
		"9": "Genders Nonconforming",
		"20": "Trans Women",
		"8": "Genderqueers"
	},
	"GENTATIONS_BY_INTEREST": {
		"1": {
			"1": 20,
			"3": 63,
			"2": 34
		},
		"3": {
			"1": 16,
			"3": 63,
			"2": 32
		},
		"2": {
			"1": 17,
			"3": 63,
			"2": 40
		}
	},
	"ORIENTATION_MAPPINGS": {
		"code": [0, 1, 2, 3],
		"full": ["Unknown", "Straight", "Gay", "Bisexual"],
		"short": ["Un", "Str", "Gay", "Bi"]
	},
	"GENDER_TAGS": {
		"18": "Transmasculine",
		"19": "Transsexual",
		"5": "Cis Man",
		"4": "Bigender",
		"7": "Genderfluid",
		"6": "Cis Woman",
		"1": "Man",
		"14": "Pangender",
		"0": "Woman",
		"15": "Transfeminine",
		"3": "Androgynous",
		"16": "Transgender",
		"2": "Agender",
		"17": "Trans Man",
		"10": "Hijra",
		"11": "Intersex",
		"12": "Non-binary",
		"21": "Two Spirit",
		"13": "Other",
		"9": "Gender Nonconforming",
		"20": "Trans Woman",
		"8": "Genderqueer"
	},
	"GENDER_KEYS": [0, 1, 2],
	"ORIENTATION_ALIASES": {
		"BISEXUAL": 3,
		"str": 1,
		"gay": 2,
		"Bisexual": 3,
		"unknown": 0,
		"STRAIGHT": 1,
		"GAY": 2,
		"Str": 1,
		"Gay": 2,
		"STR": 1,
		"un": 0,
		"Un": 0,
		"UNKNOWN": 0,
		"UN": 0,
		"Straight": 1,
		"1": 1,
		"0": 0,
		"Unknown": 0,
		"3": 3,
		"2": 2,
		"BI": 3,
		"bi": 3,
		"Bi": 3,
		"straight": 1,
		"bisexual": 3
	},
	"ORIENTATION_TAG_ORDER": ["0", "1", "2", "3", "4", "6", "5", "7", "8", "9", "10", "11"],
	"GENDER_TAG_ORDER": ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "18", "19", "17", "20", "21"],
	"ORIENTATION_TAGS": {
		"7": "Lesbian",
		"6": "Heteroflexible",
		"1": "Gay",
		"0": "Straight",
		"3": "Asexual",
		"10": "Questioning",
		"2": "Bisexual",
		"11": "Sapiosexual",
		"9": "Queer",
		"8": "Pansexual",
		"5": "Homoflexible",
		"4": "Demisexual"
	},
	"GENDER_TAG_MAPPING": {
		"trans_man": 17,
		"agender": 2,
		"bigender": 4,
		"man": 1,
		"genderqueer": 8,
		"genderfluid": 7,
		"woman": 0,
		"androgynous": 3,
		"transsexual": 19,
		"two_spirit": 21,
		"hijra": 10,
		"nonbinary": 12,
		"transgender": 16,
		"intersex": 11,
		"cis_woman": 6,
		"cis_man": 5,
		"other": 13,
		"trans_woman": 20,
		"pangender": 14,
		"transfeminine": 15,
		"gender_nonconforming": 9,
		"transmasculine": 18
	},
	"ORIENTATION_TAG_MAPPING": {
		"lesbian": 7,
		"demisexual": 4,
		"asexual": 3,
		"straight": 0,
		"questioning": 10,
		"queer": 9,
		"gay": 1,
		"homoflexible": 5,
		"heteroflexible": 6,
		"pansexual": 8,
		"bisexual": 2
	},
	"ORIENTATION_TO_TAG": {
		"1": 0,
		"3": 2,
		"2": 1
	},
	"GENDER_MAPPINGS": {
		"code": [0, 1, 2],
		"full": ["-", "Man", "Woman"],
		"letter": ["-", "M", "F"],
		"short": ["-", "M", "F"]
	}
};



// WEBPACK FOOTER //
// ./src/shared/dictionaries/gentation.js